import React from 'react';
import Fab from '@material-ui/core/Fab';
import Tooltip from '@material-ui/core/Tooltip';
import clsx from 'clsx';
import strings from 'strings';
import { FPIcon } from 'UI/components/atoms';
import { SvgMakeAi } from 'UI/res';

import { ICON_SIZE } from './FloatingButton.constants';
import { useFloatingButton } from './FloatingButton.hooks';
import { useStyles } from './FloatingButton.styled';

export const FloatingButton = ({ initialY, onClick, storageKey }) => {
  const classes = useStyles();

  const {
    handleClick,
    handleKeyDown,
    handlePointerDown,
    handlePointerMove,
    handlePointerUp,
    position,
    snapping
  } = useFloatingButton({
    initialY,
    onClick,
    storageKey
  });

  return (
    <div
      aria-label={strings.ai.generators.actions.openAssistant}
      className={clsx(classes.root, { [classes.rootSnapping]: snapping })}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      onPointerCancel={handlePointerUp}
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={handlePointerUp}
      role="button"
      tabIndex={0}
      style={{ left: position.x, top: position.y }}
    >
      <Tooltip title={strings.ai.generators.actions.openAssistant} placement="left">
        <Fab className={classes.fab}>
          <FPIcon component={SvgMakeAi} size={ICON_SIZE} color="white" />
        </Fab>
      </Tooltip>
    </div>
  );
};
